import types from './actionTypes';

export const newsRequest = meta => ({
    type: types.NEWS_REQUEST,
    meta,
});

export const newsRequestCompleted = () => ({
    type: types.NEWS_REQUEST_COMPLETED,
});

export const newsDetailRequest = ({ id, delayed = false, silent = false }) => ({
    type: types.NEWS_DETAIL_REQUEST,
    meta: {
        silent,
        delayed,
    },
    payload: {
        id,
    },
});

export const newsDetailRequestCompleted = () => ({
    type: types.NEWS_DETAIL_REQUEST_COMPLETED,
});

export const addNewsRequest = (form, payload) => ({
    type: types.ADD_NEWS_REQUEST,
    meta: {
        form,
    },
    payload,
});

export const updateNewsRequest = (form, id, payload) => ({
    type: types.UPDATE_NEWS_REQUEST,
    meta: {
        form,
        id,
    },
    payload,
});

export const deleteNewsRequest = ({ id, delayed }) => ({
    type: types.DELETE_NEWS_REQUEST,
    meta: {
        id,
        delayed,
    },
});

export const deleteNewsRequestCompleted = id => ({
    type: types.DELETE_NEWS_REQUEST_COMPLETED,
    meta: {
        id,
    },
});
